<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="400"
    >
      <v-card>
        <v-toolbar
          dark
          dense
          color="blue darken-1"
        >
          <v-toolbar-title>
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="showDialog=false"
          >
            <v-icon small>
              close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="frozenRows.length">
            <div
              v-for="ledger in frozenRows"
              :key="ledger.frzid"
              class="mb-2"
            >
              <v-layout class="pa-2">
                <v-avatar
                  size="30"
                  color="red"
                  class="title white--text"
                >
                  凍
                </v-avatar>
                <v-flex class="ml-2">
                  {{ ledger.frzBrief }}
                  <span class="grey--text ml-1 caption">
                    {{ ledger.frzSource }}
                  </span>

                  <div class="caption grey--text">
                    {{ ledger.createdTime | dateFormat }}
                  </div>
                </v-flex>
                <div>
                  <span class="red--text"> - {{ ledger.frzAmount }}</span>
                </div>
              </v-layout>
              <v-divider class="my-1" />
            </div>
          </div>
          <div
            v-else
            class="py-10 text-center"
          >
            暫無數據
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      showDialog: false,
      coinType: 'T',
    }
  },
  computed: {
    profileDetail () {
      return this.$store.state.wallet.profile.viewData
    },
    title () {
      return `${this.coinType}幣凍結明細`
    },
    frozenRows () {
      if (this.coinType === 'M') {
        return this.profileDetail.creditdgFrozenRows || []
      }
      return this.profileDetail.ledgerfrozen || []
    },
  },
  created () {
  },
  methods: {
    open (coinType = 'T') {
      this.coinType = coinType
      this.$store.dispatch('wallet/profile/view')
      this.showDialog = true
    },
  },
}
</script>
